<template>
    <footer class="px-4 py-5">
        <div class="row">
            <div class="col-lg-2 col-sm-4">
                <img src="../assets/images/Logo black.png" class="w-100" alt="">
                <div class="mt-3">
                    <a class="text-white text-decoration-none" href="mailto:admin@topment.fr">admin@topment.fr</a>
                    <div>Paris, France</div>
                </div>
            </div>
            <div class="col-lg-10 col-sm-8">
                <div class="row">
                    <div class="col-lg-4 col-sm-4">
                        <div class="text-white my-2">Career</div>
                        <div class="link-hover" @click="goto('landing-page')">Upload CV</div>
                        <div class="my-2 link-hover" @click="goto('dashboard-careers')">Career Dashboard</div>
                        <div class="link-hover" @click="goto('occupations')">Occupations</div>
                    </div>
                    <div class="col-lg-4 col-sm-4">
                        <div class="text-white my-2">Other Tools</div>
                        <div class="link-hover" @click="goto('skills')">Skill Standardization</div>
                        <div class="my-2 link-hover" @click="goto('job')">Job Standardization</div>
                    </div>
                    <div class="col-lg-4 col-sm-4">
                        <div class="text-white my-2">Support</div>
                        <div class="link-hover" @click="goto('privacy-policy')">Privacy Policy</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col text-center mt-3">
                &copy; {{ new Date().getFullYear() }} Topment
            </div>
        </div>
    </footer>
</template>
<script>
import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';

export default defineComponent({
    setup(){
        const router = useRouter()

        function goto(value) {
        if(localStorage.getItem('user_id')&&value=='skills') {
          router.push({name:'skills'})
        }
        else if(localStorage.getItem('user_id')&&value=='job') {
          router.push({name:'job'})
        }
        else if(value){
            router.push({name:value})
        }
        else {
          router.push({name:'signin'})
        }
      }


        return {
            router,
            goto
        }
    }
})
</script>
<style lang="scss" scoped>
footer {
    background-color: var(--tm-surface-sunk);
    color: var(--tm-ink-muted);
    border-top: 1px solid var(--tm-border);
}

footer :deep(.text-white) {
    color: var(--tm-ink) !important;
    font-weight: 600;
}

.link-hover {
    cursor: pointer;
    color: var(--tm-ink-muted);
    &:hover {
        color: var(--tm-ink);
    }
}
</style>